module.exports = __webpack_public_path__ + "static/media/appliance-warranty-resources.a0798a8a.jpg";